export default "__VITE_ASSET__BcpzHKhl__"